import React from 'react';
import CheckBox from 'devextreme-react/check-box';
import { SPSyncResult } from '../../../api/v2/SPSyncApi';

interface SPSyncSummaryBarProps {
    result: SPSyncResult;
    showOnlyDiffs: boolean;
    setShowOnlyDiffs: (val: boolean) => void;
    children?: React.ReactNode;
}

const SPSyncSummaryBar: React.FC<SPSyncSummaryBarProps> = ({ result, showOnlyDiffs, setShowOnlyDiffs, children }) => {
    return (
        <div style={{ display: 'flex', gap: '20px', marginBottom: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <span>Total: <strong>{result.totalRows}</strong></span>
            <span style={{ color: '#28a745' }}>Match: <strong>{result.matchCount}</strong></span>
            <span style={{ color: '#dc3545' }}>Mismatch: <strong>{result.mismatchCount}</strong></span>
            <span style={{ color: '#fd7e14' }}>DB Only: <strong>{result.dbOnlyCount}</strong></span>
            <span style={{ color: '#6f42c1' }}>SP Only: <strong>{result.spOnlyCount}</strong></span>
            <span style={{ marginLeft: '20px' }}>
                <CheckBox
                    text="Show only differences"
                    value={showOnlyDiffs}
                    onValueChanged={(e) => setShowOnlyDiffs(e.value)}
                />
            </span>
            {children}
        </div>
    );
};

export default SPSyncSummaryBar;
